import { jsx as _jsx, jsxs as _jsxs } from "@fluentui/react-jsx-runtime/jsx-runtime";
import { assertSlots } from '@fluentui/react-components';
import { Preview, PreviewContent, PreviewTrigger } from '@fluentai/react-preview';
/**
 * Render the final JSX of SensitivityTooltip
 */
export const renderSensitivityTooltip_unstable = state => {
  assertSlots(state);
  return /*#__PURE__*/_jsx(state.root, {
    children: state.previewSurface && /*#__PURE__*/_jsxs(Preview, {
      trapFocus: true,
      positioning: state.positioning,
      children: [/*#__PURE__*/_jsx(PreviewTrigger, {
        children: state.trigger && /*#__PURE__*/_jsx(state.trigger, {})
      }), /*#__PURE__*/_jsx(state.previewSurface, {
        children: /*#__PURE__*/_jsxs(PreviewContent, {
          children: [state.heading && /*#__PURE__*/_jsx(state.heading, {}), state.message && /*#__PURE__*/_jsx(state.message, {})]
        })
      })]
    })
  });
};
//# sourceMappingURL=renderSensitivityTooltip.js.map